export default "__VITE_ASSET__N5Oie$MS__"